/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_Browser_AInputs */

const en_gc_resources_faq_browser_a = /** @type {(inputs: Gc_Resources_Faq_Browser_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Launch GridCraft online from this site to use the official WebAssembly build. Workbook processing happens locally in your browser. Use File > Save As and the download control to keep your changes as XLSX. Closing or refreshing the tab can lose unsaved work; browser downloads remain your responsibility.`)
};

const zh_gc_resources_faq_browser_a = /** @type {(inputs: Gc_Resources_Faq_Browser_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。从本站启动 GridCraft，即可使用官方 WebAssembly 版本。工作簿在浏览器本地处理。通过“文件 > 另存为”中的下载操作保存 XLSX。关闭或刷新标签页可能丢失未保存内容，请确认文件已下载。`)
};

/**
* | output |
* | --- |
* | "Yes. Launch GridCraft online from this site to use the official WebAssembly build. Workbook processing happens locally in your browser. Use File > Save As an..." |
*
* @param {Gc_Resources_Faq_Browser_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_browser_a = /** @type {((inputs?: Gc_Resources_Faq_Browser_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_Browser_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_browser_a(inputs)
	return zh_gc_resources_faq_browser_a(inputs)
});
export { gc_resources_faq_browser_a as "gc.resources.faq.browser.a" }